import React, { Component } from "react";
import logo from "./images/logo.jpg";
import siteMain from "./images/facility-south-01.jpg";
import siteNorth from "./images/facility-north-01sm.jpg";
import siteSouth from "./images/facility-south-02sm.jpg";
import "./App.css";
import ReactGA from "react-ga";
ReactGA.initialize("UA-112037396-1");

class App extends Component {
  render() {
    ReactGA.pageview("/");
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-Title">
            Need self storage for your entire house, a small closet or a place
            to put your boxes?
          </h1>
          <h2>Whatever your storage needs, we have the solution for you.</h2>
        </header>
        <div className="">
          <img
            src={siteMain}
            className="Full-Width-Image"
            alt="GlenMark Site"
          />
        </div>
        <div className="Body">
          <div className="Text">
            <p>
              We have two facilities to serve you, one on each end of willits
              along Highway 101.
            </p>
            <p>
              In addition to self storage, we offer boxes, locks, bubble guard,
              packing tape and more to help you with your moving and self
              storage needs.
            </p>
          </div>
          <div className="Card-Holder">
            <div className="Card">
              <img src={siteSouth} className="Card-Image" alt="site image" />
              <h1>South Facility</h1>
              1788 South Main Street
              <br />
              (707) 459-4628
              <ul>
                <li>GlenMark Office</li>
                <li>24 Hour Access</li>
                <li>Individual Door alarms</li>
                <li>Video Cameras</li>
                <li>Packing Supplies</li>
              </ul>
              <a
                href="https://www.smdservers.net/SLWebSiteTemplate_V2/ReserveOnly.aspx?sCorpCode=tPMLMXfHEmTpkYhLq0OBhQ==&amp;sLocationCode=hqFZTTuWsckQxgIDaX4ymw==&amp;1=1"
                className="Button"
              >
                Rent a Unit at GlenMark South
              </a>
              <br />
              <a
                href="https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=tPMLMXfHEmTpkYhLq0OBhQ==&amp;sLocationCode=hqFZTTuWsckQxgIDaX4ymw==&amp;1=1"
                className="Button"
              >
                Online Payment GlenMark South
              </a>
            </div>
            <div className="Card">
              <img src={siteNorth} className="Card-Image" alt="site image" />
              <h1>North Facility</h1>
              395 North Main Street
              <br />
              (707) 459-4628
              <ul>
                <li>24 Hour Access</li>
                <li>Individual Door alarms</li>
                <li>Video Cameras</li>
              </ul>
              <a
                href="https://www.smdservers.net/SLWebSiteTemplate_V2/ReserveOnly.aspx?sCorpCode=tPMLMXfHEmTpkYhLq0OBhQ==&amp;sLocationCode=F3e81MY3f4IcaovtqM7F3w==&amp;1=1"
                class="Button"
              >
                Rent a Unit at GlenMark North
              </a>
              <br />
              <a
                href="https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=tPMLMXfHEmTpkYhLq0OBhQ==&amp;sLocationCode=F3e81MY3f4IcaovtqM7F3w==&amp;1=1"
                class="Button"
              >
                Online Payment GlenMark North
              </a>
            </div>
          </div>
        </div>
        <div className="Footer-Border" />
        <div className="Footer">
          <small>Mail payments to:</small>
          <ul>
            <li>GlenMark Self Storage</li>
            <li>1788 South Main Street</li>
            <li>Willits, CA 95490</li>
            <li>(707) 459-4628</li>
            <li>
              <small>glenmarkstorage@gmail.com</small>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js